module.exports = __webpack_public_path__ + "static/media/question_img.30daf0de.svg";